'use client';
import { memo } from 'react';
import { VStack, Text, Center, Stack } from '@chakra-ui/react';

import NextImage from 'shared/NextImage';

const AdvantageCard = ({
  icon,
  title,
  description,
  cardProps = null,
  iconProps = null,
  textContainerProps = null,
  titleProps = null,
  descriptionProps = null,
}) => (
  <Stack
    w="full"
    h={{ desktop: '480px', laptop: '400px', mobile: '340px' }}
    borderRadius={{ desktop: '48px', mobile: '24px' }}
    gap="0"
    bgColor="bg.white"
    spacing="48px"
    justify="space-between"
    {...cardProps}
  >
    <Center
      boxSize={{ laptop: '64px', mobile: '40px' }}
      bgColor="bg.white"
      m={{ mobile: '8px', laptop: '12px' }}
      borderRadius="50%"
      flexShrink="0"
      {...iconProps}
    >
      <NextImage
        src={icon}
        alt="Иконка"
        w="auto"
        h="auto"
        boxSize={{ laptop: '32px', mobile: '24px' }}
      />
    </Center>

    <VStack
      w="full"
      align="start"
      gap={{ mobile: '12px', laptop: '20px', desktop: '16px' }}
      p={{ laptop: '48px', tablet: '22.5px', mobile: '24px' }}
      pt="0 !important"
      {...textContainerProps}
    >
      <Text as="h3" fontSize={{ mobile: '18px', laptop: '24px' }} {...titleProps}>
        {title}
      </Text>

      <Text
        textStyle="h1"
        fontWeight="500"
        fontSize={{ mobile: '16px', laptop: '20px', desktop: '18px' }}
        {...descriptionProps}
      >
        {description}
      </Text>
    </VStack>
  </Stack>
);

export default memo(AdvantageCard);
